
document.addEventListener("DOMContentLoaded", () => {
  const boxes = document.querySelectorAll(".path-box");
  let delay = 0;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {

          // stagger animation smoothly
          entry.target.style.transitionDelay = `${delay}ms`;
          delay += 180;

          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.45,              // slower trigger
      rootMargin: "0px 0px -15% 0px" // reduces snap-in effect
    }
  );

  boxes.forEach((box) => observer.observe(box));
});

